import { render, staticRenderFns } from "./ResetPasword.vue?vue&type=template&id=cfceece8&scoped=true&"
import script from "./ResetPasword.vue?vue&type=script&lang=js&"
export * from "./ResetPasword.vue?vue&type=script&lang=js&"
import style0 from "./_resetPassword.scss?vue&type=style&index=0&id=cfceece8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfceece8",
  null
  
)

export default component.exports